import React from 'react';
import { LedgerDialog } from '../ui';
import { cn } from '../../lib/cn';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  severity?: 'error' | 'warning' | 'info';
}

const CANCEL_BUTTON_CLASS =
  'cursor-pointer border border-ink px-3 py-1.5 text-scale-1 text-ink hover:bg-paper-raised disabled:cursor-default disabled:opacity-60';

const ACCENT_BUTTON_CLASS =
  'cursor-pointer bg-accent px-3 py-1.5 text-scale-1 font-semibold text-paper hover:bg-accent-hover disabled:cursor-default disabled:opacity-60';

const DESTRUCTIVE_BUTTON_CLASS = cn(ACCENT_BUTTON_CLASS, 'bg-sev-critical hover:bg-sev-critical/90');

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  severity = 'warning',
}) => (
  <LedgerDialog
    open={open}
    onOpenChange={(next) => {
      if (!next) onCancel();
    }}
    title={title}
    description={message}
    size="sm"
    footer={
      <>
        <button type="button" onClick={onCancel} className={CANCEL_BUTTON_CLASS}>
          {cancelText}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          className={severity === 'error' ? DESTRUCTIVE_BUTTON_CLASS : ACCENT_BUTTON_CLASS}
        >
          {confirmText}
        </button>
      </>
    }
  >
    {null}
  </LedgerDialog>
);

export default ConfirmDialog;
